import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import HomePage from "./pages/HomePage";
import CityPage from "./pages/CityPage";
import BecomePartnerPage from "./pages/BecomePartnerPage";
import CIBILScorePage from "./pages/CIBILScorePage";
import EMICalculatorPage from "./pages/EMICalculatorPage";
import EligibilityCalculatorPage from "./pages/EligibilityCalculatorPage";
import OverdraftCalculatorPage from "./pages/OverdraftCalculatorPage";
import HomeLoanOverdraftCalculatorPage from "./pages/HomeLoanOverdraftCalculatorPage";
import BalanceTransferCalculatorPage from "./pages/BalanceTransferCalculatorPage";
import BuyVsRentCalculatorPage from "./pages/BuyVsRentCalculatorPage";
import PrepaymentCalculatorPage from "./pages/PrepaymentCalculatorPage";
import AboutUsPage from "./pages/AboutUsPage";
import InsightPage from "./pages/InsightPage";
import InsightsHubPage from "./pages/InsightsHubPage";
import CalculatorsHubPage from "./pages/CalculatorsHubPage";
import SolutionCategoryPage from "./pages/SolutionCategoryPage";
import LeadsPage from "./pages/LeadsPage";
import ProductPage from "./pages/ProductPage";
import NotFoundPage from "./pages/NotFoundPage";
import IndustryPage from "./pages/IndustryPage";
import IndustriesIndexPage from "./pages/IndustriesIndexPage";
import { PRODUCTS } from "./data/products";
import { Toaster } from "./components/ui/sonner";
import { Seo } from "./components/Seo";
import { ChatBot } from "./components/ChatBot";
import { ScrollToTop } from "./components/ScrollToTop";
import AIChatbot from "./components/AIChatbot";

export function AppContent() {
  return (
    <>
      <ScrollToTop />
      <Seo />
      <ChatBot />
      <AIChatbot />
      <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/my-leads" element={<LeadsPage />} />
          {Object.keys(PRODUCTS).map((slug) => (
            <Route key={slug} path={`/${slug}`} element={<ProductPage slug={slug} />} />
          ))}
          <Route path="/login" element={<Navigate to="/" replace />} />
          <Route path="/industries" element={<IndustriesIndexPage />} />
          <Route path="/industries/:slug" element={<IndustryPage />} />
          <Route path="/locations/:city" element={<CityPage />} />
          <Route path="/partner" element={<BecomePartnerPage />} />
          <Route path="/become-a-partner" element={<BecomePartnerPage />} />
          <Route path="/become-partner" element={<BecomePartnerPage />} />
          <Route path="/cibil-score" element={<CIBILScorePage />} />
          
          {/* Calculator Pages */}
          <Route path="/calculators/emi" element={<EMICalculatorPage />} />
          <Route path="/calculators/eligibility" element={<EligibilityCalculatorPage />} />
          <Route path="/calculators/overdraft" element={<OverdraftCalculatorPage />} />
          <Route path="/calculators/home-loan-overdraft" element={<HomeLoanOverdraftCalculatorPage />} />
          {/* Temporarily redirect missing calculators to homepage */}
          <Route path="/calculators/balance-transfer" element={<BalanceTransferCalculatorPage />} />
          <Route path="/calculators/buy-vs-rent" element={<BuyVsRentCalculatorPage />} />
          <Route path="/calculators/prepayment" element={<PrepaymentCalculatorPage />} />
          <Route path="/about-us" element={<AboutUsPage />} />
          <Route path="/insights" element={<InsightsHubPage />} />
          <Route path="/insights/:slug" element={<InsightPage />} />
          <Route path="/calculators" element={<CalculatorsHubPage />} />
          <Route path="/tools" element={<Navigate to="/calculators" replace />} />
          <Route path="/solutions/:categorySlug" element={<SolutionCategoryPage />} />
          
          {/* Legacy loan-product slugs -> canonical product pages */}
          <Route path="/home-loans" element={<Navigate to="/home-loan" replace />} />
          <Route path="/homesaver-home-loans" element={<Navigate to="/home-loan" replace />} />
          <Route path="/working-capital-loan" element={<Navigate to="/working-capital-finance" replace />} />
          <Route path="/cgtsme-loan" element={<Navigate to="/cgtmse-loan" replace />} />
          <Route path="/unsecured-business-loan" element={<Navigate to="/business-loans" replace />} />
          <Route path="/commercial-property-purchase-loan" element={<Navigate to="/commercial-property-purchase" replace />} />
          <Route path="/balance-transfer-with-topup" element={<HomePage />} />
          
          {/* Old Calculator Routes - Redirect */}
          <Route path="/calculator/home-loan-emi" element={<EMICalculatorPage />} />
          <Route path="/calculator/personal-loan-emi" element={<EMICalculatorPage />} />
          <Route path="/calculator/home-loan-eligibility" element={<EligibilityCalculatorPage />} />
          <Route path="/calculator/car-loan-emi" element={<EMICalculatorPage />} />
          <Route path="/calculator/education-loan-emi" element={<EMICalculatorPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
    </>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AppContent />
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;
